import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import PhotoGallery from "../components/photogallery"
import SEO from "../components/seo"

const IndexPage = ({ data }) => (
  <Layout>
    <SEO title="Ariel Chait" />
    <PhotoGallery />
  </Layout>
)

export default IndexPage
